import React from 'react';
import './nav.css';
import { useNavigate } from 'react-router-dom';
import { useSettings } from './Settingscontext';
import { useSound } from '../../hooks/useSound';
import { useProgress } from '../../hooks/useProgress';
import icon1 from '../../assets/backIcon.png';
import icon2 from '../../assets/characters.png';
import icon3 from '../../assets/settings.png';

const Nav = (props) => {
    const navigate = useNavigate();
    const { openSettings } = useSettings();
    const { coins } = useProgress();
    const { playHover, playClick } = useSound();

    const handleBack = () => {
        playClick();
        if (window.history.length > 1) {
            navigate(-1);
        } else {
            navigate('/splash');
        }
    };

    const handleCharacters = () => { playClick(); navigate('/characters'); };
    const handleSettings   = () => { playClick(); openSettings(); };

    return ( 
        <header>
            <nav>
                <li className='back' onClick={handleBack} onMouseEnter={playHover}>
                    <img className='navicons' src={icon1} alt="" />
                    <h6>BACK</h6>
                </li>
                <li className='characterss' onClick={handleCharacters} onMouseEnter={playHover}>
                    <img className='navicons' src={icon2} alt="" />
                    <h6>VIEW CHARACTERS</h6>
                </li>
                <li className='settings' onClick={handleSettings} onMouseEnter={playHover}>
                    <img className='navicons' src={icon3} alt="" />
                    <h6>OPEN SETTINGS</h6>
                </li>
            </nav>
            <article className='titlecont'>
                <h1>{props.title}</h1>
                <h4>{props.sub}</h4>
            </article>
            <div className='moneycount'>
                <h5 className='coinamount'>{coins}</h5>
                <div className='coin'></div>
            </div>
        </header>
    );
}
 
export default Nav;
